export const backgroundClasses = [
  'bg-[#9E5A2C]',
  'bg-[#9B512C]',
  'bg-[#934A2E]',
  'bg-[#7E4435]',
  'bg-[#693E3C]',
  'bg-[#523743]',
  'bg-[#3E314C]',
  'bg-[#382F53]',
  'bg-[#2F2B60]',
  'bg-[#282364]',
  'bg-[#272475]',
];
